import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { ccmStatusesDataSource } from 'infrastructure/data-sources/ccm-statuses';

import type { CcmStatuses } from 'infrastructure/enums';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { ICcmStatusItem } from 'infrastructure/data-sources/ccm-statuses';

type Options = IBaseSelectBoxOption<ICcmStatusItem['id'], ICcmStatusItem>[];

interface ICcmStatusSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {
  withAll?: boolean;
  excludeStatuses?: CcmStatuses[];
  includeStatuses?: CcmStatuses[];
}

const CcmStatusSelectBox: React.FC<ICcmStatusSelectBoxProps> = (props) => {
  const { withAll, excludeStatuses, includeStatuses } = props;
  const dataSource = useMemo(
    () => ccmStatusesDataSource(withAll, excludeStatuses, includeStatuses),
    [withAll, excludeStatuses, includeStatuses],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default CcmStatusSelectBox;
